/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultRange } from './ResultRange';
import {
    ResultRangeFromJSON,
    ResultRangeFromJSONTyped,
    ResultRangeToJSON,
} from './ResultRange';
import type { PageSort } from './PageSort';
import {
    PageSortFromJSON,
    PageSortFromJSONTyped,
    PageSortToJSON,
} from './PageSort';
import type { ClaimFormSearchResult } from './ClaimFormSearchResult';
import {
    ClaimFormSearchResultFromJSON,
    ClaimFormSearchResultFromJSONTyped,
    ClaimFormSearchResultToJSON,
} from './ClaimFormSearchResult';

/**
 * 
 * @export
 * @interface PageClaimFormSearchResult
 */
export interface PageClaimFormSearchResult {
    /**
     * 
     * @type {Array<ClaimFormSearchResult>}
     * @memberof PageClaimFormSearchResult
     */
    results: Array<ClaimFormSearchResult>;
    /**
     * 
     * @type {number}
     * @memberof PageClaimFormSearchResult
     */
    totalResults: number;
    /**
     * 
     * @type {PageSort}
     * @memberof PageClaimFormSearchResult
     */
    sort: PageSort;
    /**
     * 
     * @type {ResultRange}
     * @memberof PageClaimFormSearchResult
     */
    resultRange: ResultRange;
}

/**
 * Check if a given object implements the PageClaimFormSearchResult interface.
 */
export function instanceOfPageClaimFormSearchResult(value: object): value is PageClaimFormSearchResult {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('resultRange' in value) || value['resultRange'] === undefined) return false;
    return true;
}

export function PageClaimFormSearchResultFromJSON(json: any): PageClaimFormSearchResult {
    return PageClaimFormSearchResultFromJSONTyped(json, false);
}

export function PageClaimFormSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageClaimFormSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ClaimFormSearchResultFromJSON)),
        'totalResults': json['totalResults'],
        'sort': PageSortFromJSON(json['sort']),
        'resultRange': ResultRangeFromJSON(json['resultRange']),
    };
}

export function PageClaimFormSearchResultToJSON(value?: PageClaimFormSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(ClaimFormSearchResultToJSON)),
        'totalResults': value['totalResults'],
        'sort': PageSortToJSON(value['sort']),
        'resultRange': ResultRangeToJSON(value['resultRange']),
    };
}

